var map = {
	"./bainian.png": "8d8b",
	"./chayao.png": "16b6",
	"./dazhaohu.png": "3c1d",
	"./haixiu.png": "4593",
	"./huanhu.png": "d8c5",
	"./pao.png": "f38e",
	"./shengqi.png": "aef1",
	"./tiao.png": "41b2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6ced";